import React from 'react';
import { Link } from 'react-router-dom';

export class BadCatentryId extends React.Component {
  render() {
    return (
      <section id='BadCatentryIdDisplay'>
        <div className='row'>
          <div className='col-sm-12 col-md-12 col-lg-12'>
            <div id='' className='alert alert-danger' role='alert'>
              The item you are looking for is currently not available on Dillards.com.
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-sm-12 popularLinks'>
            <ul>
              <li>
                <Link to='/'>Visit the Dillards.com homepage</Link>
              </li>
              <li>
                <Link to='/c/customerservice'>Contact Dillard&apos;s Customer Service</Link>
              </li>
            </ul>
          </div>
        </div>
      </section>
    );
  }
}

export default BadCatentryId;
